<script setup lang="ts">

type Props = {
    disabled?: boolean,
    variant?: 'button' | 'option',
    selected?: boolean,
    flat?: boolean
}
const { variant = 'option' } = defineProps<Props>();

</script>

<template>
    <button
        class="rounded-md p-3 min-w-[5rem] min-h-[4rem]
               tracking-wider text-base font-semibold
               flex flex-col items-center justify-center transition duration-150"
        :disabled="disabled === true"
        :class="[
            variant == 'option' && selected === true ? 'ring ring-white/40' : '',
            flat === true ? 'hover:bg-white/[8%]' : ( variant === 'button' === true || selected === true ? 'bg-white text-black' : 'bg-white/[8%] hover:bg-white/[15%]' ),
            {
                'opacity-20 pointer-events-none': disabled === true,
            }
        ]">
        <slot></slot>
    </button>
</template>